// extracted by mini-css-extract-plugin
export default {"actions":"ResetPassword_actions__sb6F4"};